import { render, staticRenderFns } from "./ResultsCalculationElements.vue?vue&type=template&id=4406bad3"
import script from "./ResultsCalculationElements.vue?vue&type=script&lang=ts"
export * from "./ResultsCalculationElements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports